import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  FormHelperText,
  IconButton,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { ModalBox } from "../../../styles/ModalStyles";
import CloseIcon from "@mui/icons-material/Close";

const NuevoUsuarioModal = ({ open, onClose, onSubmit }) => {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [correo, setCorreo] = useState("");
  const [contraseña, setContraseña] = useState("");
  const [confirmarContraseña, setConfirmarContraseña] = useState("");
  const [rol, setRol] = useState("");
  const [contraseñasIguales, setContraseñasIguales] = useState(true);
  const [esProveedorExterno, setEsProveedorExterno] = useState(false);
  const [proveedorExterno, setProveedorExterno] = useState("");

  useEffect(() => {
    if (open) {
      // Resetear formulario cuando se abre
      setNombre("");
      setApellido("");
      setCorreo("");
      setContraseña("");
      setConfirmarContraseña("");
      setRol("");
      setEsProveedorExterno(false);
      setProveedorExterno("");
    }
  }, [open]);

  useEffect(() => {
    setContraseñasIguales(contraseña === confirmarContraseña);
  }, [contraseña, confirmarContraseña]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validar datos según tipo de usuario
    if (!esProveedorExterno && !contraseñasIguales) {
      return;
    }
    
    if (esProveedorExterno && !proveedorExterno) {
      return;
    }
    
    onSubmit({
      nombre,
      apellido,
      correo,
      contraseña: esProveedorExterno ? null : contraseña,
      rol,
      esProveedorExterno,
      proveedorExterno: esProveedorExterno ? proveedorExterno : null,
    });
  };

  const handleProveedorChange = (e) => {
    setEsProveedorExterno(e.target.checked);
    if (!e.target.checked) {
      setProveedorExterno("");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6">Nuevo usuario</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Apellido"
            value={apellido}
            onChange={(e) => setApellido(e.target.value)}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Correo"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            margin="normal"
            required
            type="email"
          />
          <TextField
            fullWidth
            select
            label="Rol"
            value={rol}
            onChange={(e) => setRol(e.target.value)}
            margin="normal"
            required
          >
            <MenuItem value="Usuario">Usuario</MenuItem>
            <MenuItem value="Administrador">Administrador</MenuItem>
          </TextField>
          
          <FormControlLabel
            control={
              <Checkbox
                checked={esProveedorExterno}
                onChange={handleProveedorChange}
              />
            }
            label="Usuario con proveedor externo"
          />
          
          {esProveedorExterno ? (
            <FormControl fullWidth margin="normal" required>
              <InputLabel>Proveedor</InputLabel>
              <Select
                value={proveedorExterno}
                label="Proveedor"
                onChange={(e) => setProveedorExterno(e.target.value)}
              >
                <MenuItem value="Google">Google</MenuItem>
                <MenuItem value="Microsoft">Microsoft</MenuItem>
              </Select>
            </FormControl>
          ) : (
            <>
              <TextField
                fullWidth
                label="Contraseña"
                value={contraseña}
                onChange={(e) => setContraseña(e.target.value)}
                margin="normal"
                required={!esProveedorExterno}
                type="password"
                error={!contraseñasIguales}
              />
              <TextField
                fullWidth
                label="Confirmar Contraseña"
                value={confirmarContraseña}
                onChange={(e) => setConfirmarContraseña(e.target.value)}
                margin="normal"
                required={!esProveedorExterno}
                type="password"
                error={!contraseñasIguales}
              />
              {!contraseñasIguales && (
                <FormHelperText error>Las contraseñas no coinciden</FormHelperText>
              )}
            </>
          )}
          
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mr: 1 }}
              disabled={!esProveedorExterno && !contraseñasIguales}
            >
              Guardar
            </Button>
            <Button onClick={onClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default NuevoUsuarioModal;